import { Component, Inject, OnDestroy, OnInit } from '@angular/core'
import { UntypedFormControl, Validators } from '@angular/forms'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { Subscription } from 'rxjs'

export interface SendContactEditDialogData {
  method: 'sms' | 'email'
  phone?: string
  email?: string
}

export interface SendContactEditDialogResult {
  to?: string
}

@Component({
  selector: 'mmx-send-contact-edit-dialog',
  templateUrl: './send-contact-edit-dialog.component.html',
  standalone: false,
})
export class SendContactEditDialogComponent implements OnInit, OnDestroy {
  public contactControl: UntypedFormControl
  public isCustomValue = false

  private initialValue: string
  private subscription: Subscription

  constructor(
    public dialogRef: MatDialogRef<SendContactEditDialogComponent, SendContactEditDialogResult>,
    @Inject(MAT_DIALOG_DATA) public data: SendContactEditDialogData,
  ) {}

  ngOnInit() {
    this.initialValue = (this.data.method === 'sms' ? this.data.phone : this.data.email) || ''
    const validators = this.data.method === 'email'
      ? [Validators.required, Validators.email]
      : [Validators.required]
    this.contactControl = new UntypedFormControl(this.initialValue, validators)

    this.subscription = this.contactControl.valueChanges.subscribe((value: string) => {
      this.isCustomValue = value?.trim() !== this.initialValue.trim()
    })
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe()
  }

  reset() {
    this.contactControl.setValue(this.initialValue)
  }

  send() {
    if (this.contactControl.valid) {
      this.dialogRef.close(this.isCustomValue ? { to: this.contactControl.value.trim() } : {})
    }
  }
}
